module.exports =
  '_TERM' :
    'TITLE': '利用規約'
    'ACCEPT_BUTTON': '同意する'


// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/term/i18n/ja.coffee